import { defineMessages } from 'react-intl';

export const unauthorizedMessageDefinitions = defineMessages({
  title: {
    id: 'unauthorized.title',
    defaultMessage: '403 - Unauthorized',
  },
  youDoNotHaveAccess: {
    id: 'unauthorized.youDoNotHaveAccess',
    defaultMessage: 'You do not have permission to access this page.',
  },
  homePageButton: {
    id: 'unauthorized.homePageButton',
    defaultMessage: 'Home page',
  },
});
